import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resumido'
})
export class ResumidoPipe implements PipeTransform {

  transform(value: Array<any>, ): Array<any> {
    let newArr = []

    for(let i of value){
      if(i.BalDoc>0){
        newArr.push(i)
      }
    }

    return newArr
  }

}
